import React from "react";

export const ICONS = {
  HOME: {
    viewBox: "0 0 13 14",
    path: (
      <path d="M11 7.75v3.75q0 0.203-0.148 0.352t-0.352 0.148h-3v-3h-2v3h-3q-0.203 0-0.352-0.148t-0.148-0.352v-3.75q0-0.008 0.004-0.023t0.004-0.023l4.492-3.703 4.492 3.703q0.008 0.016 0.008 0.047zM12.742 7.211l-0.484 0.578q-0.062 0.070-0.164 0.086h-0.023q-0.102 0-0.164-0.055l-5.406-4.508-5.406 4.508q-0.094 0.062-0.187 0.055-0.102-0.016-0.164-0.086l-0.484-0.578q-0.062-0.078-0.055-0.184t0.086-0.168l5.617-4.68q0.25-0.203 0.594-0.203t0.594 0.203l1.906 1.594v-1.523q0-0.109 0.070-0.18t0.18-0.070h1.5q0.109 0 0.18 0.070t0.070 0.18v3.188l1.711 1.422q0.078 0.062 0.086 0.168t-0.055 0.184z" />
    )
  },
  ARROW_LEFT: {
    viewBox: "0 0 13 14",
    path: (
      <path d="M12 7v1q0 0.414-0.254 0.707t-0.66 0.293h-5.5l2.289 2.297q0.297 0.281 0.297 0.703t-0.297 0.703l-0.586 0.594q-0.289 0.289-0.703 0.289-0.406 0-0.711-0.289l-5.086-5.094q-0.289-0.289-0.289-0.703 0-0.406 0.289-0.711l5.086-5.078q0.297-0.297 0.711-0.297 0.406 0 0.703 0.297l0.586 0.578q0.297 0.297 0.297 0.711t-0.297 0.711l-2.289 2.289h5.5q0.406 0 0.66 0.293t0.254 0.707z" />
    )
  },
  CHEVRON_DOWN: {
    viewBox: "0 0 14 14",
    path: (
      <path d="M13.148 6.312l-5.797 5.789q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.789q-0.148-0.148-0.148-0.355t0.148-0.355l1.297-1.289q0.148-0.148 0.352-0.148t0.352 0.148l4.148 4.148 4.148-4.148q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.289q0.148 0.148 0.148 0.355t-0.148 0.355z" />
    )
  },
  INFO: {
    viewBox: "0 0 5 14",
    path: (
      <path d="M5 10.5v1q0 0.203-0.148 0.352t-0.352 0.148h-4q-0.203 0-0.352-0.148t-0.148-0.352v-1q0-0.203 0.148-0.352t0.352-0.148h0.5v-3h-0.5q-0.203 0-0.352-0.148t-0.148-0.352v-1q0-0.203 0.148-0.352t0.352-0.148h3q0.203 0 0.352 0.148t0.148 0.352v4.5h0.5q0.203 0 0.352 0.148t0.148 0.352zM4 1.5v1.5q0 0.203-0.148 0.352t-0.352 0.148h-2q-0.203 0-0.352-0.148t-0.148-0.352v-1.5q0-0.203 0.148-0.352t0.352-0.148h2q0.203 0 0.352 0.148t0.148 0.352z" />
    )
  },
  SIGN_IN: {
    viewBox: "0 0 12 14",
    path: (
      <path d="M9.25 7q0 0.203-0.148 0.352l-4.25 4.25q-0.148 0.148-0.352 0.148t-0.352-0.148-0.148-0.352v-2.25h-3.5q-0.203 0-0.352-0.148t-0.148-0.352v-3q0-0.203 0.148-0.352t0.352-0.148h3.5v-2.25q0-0.203 0.148-0.352t0.352-0.148 0.352 0.148l4.25 4.25q0.148 0.148 0.148 0.352zM12 4.25v5.5q0 0.93-0.66 1.59t-1.59 0.66h-2.5q-0.102 0-0.176-0.074t-0.074-0.176q0-0.031-0.008-0.156t-0.004-0.207 0.023-0.184 0.078-0.152 0.16-0.051h2.5q0.516 0 0.883-0.367t0.367-0.883v-5.5q0-0.516-0.367-0.883t-0.883-0.367h-2.438t-0.090-0.008-0.090-0.023-0.062-0.043-0.055-0.070-0.016-0.105q0-0.031-0.008-0.156t-0.004-0.207 0.023-0.184 0.078-0.152 0.16-0.051h2.5q0.93 0 1.59 0.66t0.66 1.59z" />
    )
  },
  CLOSE: {
    viewBox: "0 0 11 14",
    path: (
      <path d="M10.141 10.328q0 0.312-0.219 0.531l-1.062 1.062q-0.219 0.219-0.531 0.219t-0.531-0.219l-2.297-2.297-2.297 2.297q-0.219 0.219-0.531 0.219t-0.531-0.219l-1.062-1.062q-0.219-0.219-0.219-0.531t0.219-0.531l2.297-2.297-2.297-2.297q-0.219-0.219-0.219-0.531t0.219-0.531l1.062-1.062q0.219-0.219 0.531-0.219t0.531 0.219l2.297 2.297 2.297-2.297q0.219-0.219 0.531-0.219t0.531 0.219l1.062 1.062q0.219 0.219 0.219 0.531t-0.219 0.531l-2.297 2.297 2.297 2.297q0.219 0.219 0.219 0.531z" />
    )
  }
};



// WEBPACK FOOTER //
// ./src/utils/constants.js